import {
  Box,
  Button,
  Divider,
  Fab,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Slide,
  TextField,
  Typography,
} from '@mui/material'
import React, { FC, useContext, useEffect, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import CheckIcon from '@mui/icons-material/Check'
import DeleteIcon from '@mui/icons-material/Delete'
import {
  DoorPropsType,
  DoorType,
  DoorVisualType,
  DrawerPropsType,
  DrawerSlideType,
  DrawerVisualType,
  HandlePositionTypes,
  HandlePositionXTypes,
  HandlePropsType,
  newDoorVisualTypeValues,
} from '../../redux/cabinetReducer'
import { ReactComponent as LeftDoorSVG } from '../../assets/leftDoor.svg'
import { ReactComponent as RightDoorSVG } from '../../assets/rightDoor.svg'
import { ReactComponent as CenterHandleSVG } from '../../assets/centerHandle.svg'
import { ReactComponent as HorizontalHandleSVG } from '../../assets/horizontalHandle.svg'
import { ReactComponent as LiftUpDoorSVG } from '../../assets/liftUpDoor.svg'
import { ReactComponent as DoubleDoorSVG } from '../../assets/doubleDoor.svg'
import { ReactComponent as TopHandleSVG } from '../../assets/topHandle.svg'
import { ReactComponent as BottomHandleSVG } from '../../assets/bottomHandle.svg'
import { ReactComponent as FromGroundSVG } from '../../assets/fromGround.svg'
import { handleFocus } from '../../common/helpers'
import { useSnackbar } from 'notistack'
import { Flex, showMessage } from '../common/Helpers'
import { ConfigsContext } from '../../common/configContext'
import useUnit from '../../hooks/useUnit'
import { cmToIn, inToCm } from '../common/UnitComponents'
import { ReactComponent as FivePiecesDoorSVG } from '../../assets/fivePiecesDoor.svg'
import { ReactComponent as ShakerDoorSVG } from '../../assets/shakerDoor.svg'
import { ReactComponent as NewDoorSVG } from '../../assets/newDoor.svg'
import { ReactComponent as VGrooveDoorSVG } from '../../assets/vGrooveDoor.svg'
import { ReactComponent as DrawerSVG } from '../../assets/drawer.svg'
import { ReactComponent as DrawerNewSVG } from '../../assets/drawerNew.svg'
import { ReactComponent as DrawerDoubleSVG } from '../../assets/drawerDouble.svg'
import { ReactComponent as DrawerLeftSVG } from '../../assets/drawerLeft.svg'
import { ReactComponent as DrawerRightSVG } from '../../assets/drawerRight.svg'
import { ReactComponent as DrawerCenterSVG } from '../../assets/drawerCenter.svg'
import {
  getNewDoorPiecesFromSplitters,
  newDoorConfigs,
} from '../../classes/3DObjects'
import { HandleOrientationType } from '../../classes/Item'
import zIndex from '@mui/material/styles/zIndex'
import { minDepthOfCabByDrawerSlideType } from '../../config'

interface ITypeButtonProps {
  selectedType: string
  type: string
  children: JSX.Element

  setType(type: string): void
}

const TypeButton: FC<ITypeButtonProps> = ({
  selectedType,
  type,
  children,
  setType,
}) => {
  const selected =
    type === '#'
      ? selectedType.startsWith('#')
      : type === 'shaker'
      ? selectedType.startsWith('shaker')
      : selectedType === type

  return (
    <Box
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: `${selected ? 2 : 1}px solid ${selected ? '#3f51b5' : 'black'}`,
        borderRadius: 8,
        height: 30,
        width: 30,
        cursor: 'pointer',
      }}
      onClick={() => {
        setType(type)
      }}
    >
      <Box
        style={{
          height: 26,
          width: 26,
        }}
      >
        {React.cloneElement(children, {
          width: '100%',
          height: '100%',
          viewBox: '0 0 100 100',
        })}
      </Box>
    </Box>
  )
}

interface IProps {
  isCorner: boolean
  isTwoDoorCorner: boolean
  cabinetDepth: number
  panelHeight: number
  left: number
  top: number
  shelfCount: number
  doorProps: DoorPropsType | undefined
  drawerProps: DrawerPropsType | undefined
  globalDoorType: DoorType
  globalHandlePosition: HandlePropsType['position']
  globalDoorVisualType: DoorVisualType
  drawerSlideType: DrawerSlideType

  setDividerMode(val: boolean): void
  removeTempShelves(): void
  addShelvesAsItem(count: number): void
  deleteShelves(): void
  unhideShelfItems(): void
  addTempDividers(): void
  removeTempDividers(): void
  setSectionDoor(type: DoorType): void
  setSectionDoorVisualType(type: DoorVisualType): void
  setSectionDrawer(): void
  deleteSectionDoor(): void
  deleteSectionDrawer(): void
  viewShelf(count: number): void
  viewDividers(count: number): void
  setSectionDoorHandlePosition(position: HandlePropsType['position']): void
  setSectionDoorHandlePositionX(positionX: HandlePropsType['positionX']): void
  setSectionDoorSplitters(value: string): void
  setSectionDrawerVisualType(type: DrawerVisualType): void
  setHandleOrientation(v: HandleOrientationType): void
  setDrawerHandleOrientation(v: HandleOrientationType): void
  setDrawerHandlePosition(position: HandlePropsType['position']): void
  setDrawerHandlePositionX(v: HandlePropsType['positionX']): void
}

const SectionActions: FC<IProps> = (props) => {
  const [shelfMode, setShelfMode] = useState(false)
  const [shelfCount, setShelfCount] = useState(
    props.shelfCount === 0 ? 1 : props.shelfCount
  )
  const [dividerMode, setDividerMode] = useState(false)
  const [dividerCount, setDividerCount] = useState(1)
  const [doorType, setDoorType] = useState<DoorType>(
    props.doorProps ? props.doorProps.type : props.globalDoorType
  )
  const [handlePos, setHandlePos] = useState<HandlePropsType['position']>(
    props.doorProps
      ? props.doorProps.handleProps.position
      : props.globalHandlePosition
  )
  const [handlePosX, setHandlePosX] = useState<HandlePropsType['positionX']>(
    props.doorProps ? props.doorProps.handleProps.positionX : 'left'
  )

  const [drawerHandlePos, setDrawerHandlePos] = useState<
    HandlePropsType['position']
  >(props.drawerProps ? props.drawerProps.handleProps.position : 'forDrawer')
  const [drawerHandlePosX, setDrawerHandlePosX] = useState<
    HandlePropsType['positionX']
  >(props.drawerProps ? props.drawerProps.handleProps.positionX : 'center')

  const [handleOrientation, setHandleOrientation] =
    useState<HandleOrientationType>(
      props.doorProps
        ? // @ts-ignore
          props.doorProps.handleProps.placement
        : 'vertical'
    )

  const [doorVisualType, setDoorVisualType] = useState<DoorVisualType>(
    props.doorProps?.visualType || props.globalDoorVisualType
  )
  const [newDoorsDistY, setNewDoorsDistY] = useState('')

  const [isNewDoorVisualType, setIsNewDoorVisualType] = useState(
    doorVisualType.startsWith('#')
  )

  const [isShakerVisualType, setIsShakerVisualType] = useState(
    props.doorProps?.visualType.startsWith('shaker')
  )

  const [isB600R100, setIsB600R100] = useState(
    doorVisualType.includes('B600-R100')
  )

  const [isNewDrawerVisualType, setIsNewDrawerVisualType] = useState(
    props.drawerProps?.visualType?.startsWith('#')
  )

  const [isDrawerShakerVisualType, setIsDrawerShakerVisualType] = useState(
    props.drawerProps?.visualType?.startsWith('shaker')
  )

  const { enqueueSnackbar } = useSnackbar()
  const { unit } = useUnit()

  useEffect(() => {
    setIsNewDoorVisualType(doorVisualType.startsWith('#'))
    setIsShakerVisualType(props.doorProps?.visualType.startsWith('shaker'))

    if (doorVisualType.startsWith('#')) {
      const doorInnerType = doorVisualType.replaceAll('-', '').slice(1, 9)
      const distY =
        // @ts-ignore
        newDoorConfigs[doorInnerType].distXY * (unit === 'cm' ? 2.54 : 1)
      setNewDoorsDistY(distY.toFixed(2))
    }
  }, [doorVisualType, unit])

  useEffect(() => {
    setIsNewDrawerVisualType(props.drawerProps?.visualType?.startsWith('#'))
    setIsDrawerShakerVisualType(
      props.drawerProps?.visualType?.startsWith('shaker')
    )

    setDrawerHandlePosX(
      props.drawerProps ? props.drawerProps.handleProps.positionX : 'center'
    )

    setDrawerHandlePos(
      props.drawerProps ? props.drawerProps.handleProps.position : 'forDrawer'
    )
  }, [props.drawerProps])

  useEffect(() => {
    // debugger
    setShelfMode(false)
    setShelfCount(props.shelfCount === 0 ? 1 : props.shelfCount)
  }, [props.left, props.top, props.shelfCount])

  useEffect(() => {
    setDoorType(props.doorProps ? props.doorProps.type : props.globalDoorType)
  }, [props.doorProps, props.globalDoorType])

  useEffect(() => {
    setHandlePos(
      props.doorProps
        ? props.doorProps.handleProps.position
        : props.globalHandlePosition
    )
    setHandlePosX(
      props.doorProps ? props.doorProps.handleProps.positionX : 'left'
    )
    setHandleOrientation(
      props.doorProps ? props.doorProps.handleProps.orientation : 'vertical'
    )
  }, [props.doorProps, props.globalHandlePosition])

  useEffect(() => {
    setDoorVisualType(props.doorProps?.visualType || props.globalDoorVisualType)
  }, [props.doorProps, props.globalDoorVisualType])

  useEffect(() => {
    setIsB600R100(doorVisualType.includes('B600-R100'))
  }, [doorVisualType])

  const turnOffShelvesMode = () => {
    props.removeTempShelves()
    props.unhideShelfItems()
    setShelfMode(false)
    setShelfCount(props.shelfCount)
  }

  const setHandlePosition = (value: HandlePositionTypes) => {
    props.setSectionDoorHandlePosition(value)
  }

  const configs = useContext(ConfigsContext)

  return (
    <>
      <Box
        style={{
          position: 'absolute',
          left: props.left + 35,
          top: props.top + 48 - 25, //48 is header height
          rowGap: 10,
          zIndex: 20,
        }}
        display="flex"
        flexDirection="column"
        // size='small'
        // color='secondary'
      >
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            if (dividerMode) {
              setDividerMode(false)
            } else {
              setDividerMode(true)
              props.viewDividers(1)
            }

            if (shelfMode) turnOffShelvesMode()
          }}
        >
          Divider
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            if (!shelfMode === true) {
              setShelfMode(true)
              props.viewShelf(props.shelfCount === 0 ? 1 : props.shelfCount)
            } else {
              turnOffShelvesMode()
            }

            if (dividerMode) {
              setDividerMode(false)
              props.setDividerMode(false)
            }
          }}
        >
          Shelf
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            props.setSectionDoor(props.globalDoorType)
          }}
        >
          Door
        </Button>
        {!props.isCorner && (
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              if (props.panelHeight < configs.drawerConfig.minimumHeight) {
                showMessage(
                  enqueueSnackbar,
                  "Drawer front panel height can't be smaller than " +
                    (unit === 'cm'
                      ? configs.drawerConfig.minimumHeight
                      : cmToIn(configs.drawerConfig.minimumHeight)) +
                    ' ' +
                    unit
                )
              } else {
                const minDepth =
                  minDepthOfCabByDrawerSlideType[props.drawerSlideType]

                if (props.cabinetDepth < minDepth) {
                  showMessage(
                    enqueueSnackbar,
                    `Drawer with ${props.drawerSlideType} slide can't be added if cabinet depth smaller than ` +
                      (unit === 'cm' ? minDepth : cmToIn(minDepth)) +
                      ' ' +
                      unit
                  )
                } else {
                  props.setSectionDrawer()
                }
              }
            }}
          >
            Drawer
          </Button>
        )}
      </Box>

      <Slide direction="up" in={!!props.drawerProps}>
        <Paper
          style={{
            position: 'absolute',
            padding: 8,
            right: 488,
            bottom: 64, //48 is header height
            display: 'flex',
            zIndex: 20,
            // alignItems: 'center',
          }}
          sx={{
            flexDirection: 'column',
            ml: 1,
          }}
        >
          <Flex centerY>
            <Typography style={{ fontSize: 18, flexGrow: 1 }}>
              Drawer Options
            </Typography>
            <Fab
              style={{
                maxWidth: 25,
                maxHeight: 25,
                minWidth: 25,
                minHeight: 25,
              }}
              color="secondary"
              onClick={() => {
                props.deleteSectionDrawer()
              }}
            >
              <DeleteIcon />
            </Fab>
          </Flex>
          <Divider
            sx={{
              margin: '8px -8px',
            }}
          />
          <Box display="flex" alignItems="center" style={{ columnGap: 5 }}>
            <TypeButton
              selectedType={
                props.drawerProps?.handleProps.orientation || 'vertical'
              }
              type="vertical"
              setType={props.setDrawerHandleOrientation}
            >
              <DrawerSVG />
            </TypeButton>
            <TypeButton
              selectedType={
                props.drawerProps?.handleProps.orientation || 'vertical'
              }
              type="double_horizontal"
              setType={props.setDrawerHandleOrientation}
            >
              <DrawerDoubleSVG />
            </TypeButton>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            style={{ columnGap: 5 }}
            mt={1}
          >
            <TypeButton
              selectedType={
                typeof drawerHandlePos === 'string' ? drawerHandlePos : 'none'
              }
              type="forDrawer"
              setType={(v) => props.setDrawerHandlePosition('forDrawer')}
            >
              <DrawerSVG />
            </TypeButton>

            <TypeButton
              selectedType={
                typeof drawerHandlePos === 'string' ? drawerHandlePos : 'none'
              }
              type="forDrawerCenter"
              setType={(v) => props.setDrawerHandlePosition('forDrawerCenter')}
            >
              <DrawerCenterSVG />
            </TypeButton>
            <TextField
              label={unit}
              variant="outlined"
              size="small"
              type="number"
              style={{
                width: 80,
              }}
              onFocus={(e) => {
                handleFocus(e)
              }}
              value={
                typeof drawerHandlePos === 'number'
                  ? unit === 'cm'
                    ? drawerHandlePos
                    : cmToIn(drawerHandlePos)
                  : -1
              }
              onChange={(e) => {
                const newValue = parseFloat(e.target.value)
                props.setDrawerHandlePosition(
                  unit === 'cm' ? newValue : inToCm(newValue)
                )
              }}
            />
          </Box>
          <Box
            display="flex"
            alignItems="center"
            style={{ columnGap: 5 }}
            mt={1}
          >
            <TypeButton
              selectedType={
                typeof drawerHandlePosX === 'string' ? drawerHandlePosX : 'none'
              }
              type="left"
              setType={(v: HandlePositionXTypes) =>
                props.setDrawerHandlePositionX(v)
              }
            >
              <DrawerLeftSVG />
            </TypeButton>
            <TypeButton
              selectedType={
                typeof drawerHandlePosX === 'string' ? drawerHandlePosX : 'none'
              }
              type="center"
              setType={(v: HandlePositionXTypes) =>
                props.setDrawerHandlePositionX(v)
              }
            >
              <DrawerSVG />
            </TypeButton>
            <TypeButton
              selectedType={
                typeof drawerHandlePosX === 'string' ? drawerHandlePosX : 'none'
              }
              type="right"
              setType={(v: HandlePositionXTypes) =>
                props.setDrawerHandlePositionX(v)
              }
            >
              <DrawerRightSVG />
            </TypeButton>

            <TextField
              label={unit}
              variant="outlined"
              size="small"
              type="number"
              style={{
                width: 80,
              }}
              onFocus={(e) => {
                handleFocus(e)
              }}
              value={
                typeof drawerHandlePosX === 'number'
                  ? unit === 'cm'
                    ? drawerHandlePosX
                    : cmToIn(drawerHandlePosX)
                  : -1
              }
              onChange={(e) => {
                const newValue = parseFloat(e.target.value)
                props.setDrawerHandlePositionX(
                  unit === 'cm' ? newValue : inToCm(newValue)
                )
              }}
            />
          </Box>
          <Box
            display="flex"
            alignItems="center"
            style={{ marginTop: 8, columnGap: 5 }}
          >
            <TypeButton
              selectedType={props.drawerProps?.visualType || 'standard'}
              type="standard"
              setType={props.setSectionDrawerVisualType}
            >
              <DrawerSVG />
            </TypeButton>
            <TypeButton
              selectedType={props.drawerProps?.visualType || 'standard'}
              type="fivePieces"
              setType={props.setSectionDrawerVisualType}
            >
              <DrawerSVG />
            </TypeButton>
            <TypeButton
              selectedType={props.drawerProps?.visualType || 'standard'}
              type="#"
              setType={() => {
                props.setSectionDrawerVisualType(newDoorVisualTypeValues[0])
              }}
            >
              <DrawerNewSVG />
            </TypeButton>
            <TypeButton
              selectedType={props.drawerProps?.visualType || 'standard'}
              type="shaker"
              setType={() => props.setSectionDrawerVisualType('shaker_h')}
            >
              <DrawerSVG />
            </TypeButton>
          </Box>
          {isNewDrawerVisualType && (
            <Flex sx={{ mt: 2 }} column gap={1}>
              <FormControl size="small" sx={{ width: 180 }}>
                <InputLabel>New Drawer Visual Type</InputLabel>
                <Select
                  defaultValue={newDoorVisualTypeValues[0]}
                  value={
                    props.drawerProps?.visualType || newDoorVisualTypeValues[0]
                  }
                  label={'New Drawer Visual Type'}
                  onChange={(e) => {
                    props.setSectionDrawerVisualType(
                      e.target.value as DrawerVisualType
                    )
                  }}
                >
                  {newDoorVisualTypeValues.map((v) => (
                    <MenuItem value={v} key={'dv' + v}>
                      {v}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Flex>
          )}
          {isDrawerShakerVisualType && (
            <FormControl component="fieldset">
              <RadioGroup
                row
                value={
                  props.drawerProps?.visualType
                    ? props.drawerProps?.visualType[
                        props.drawerProps?.visualType.length - 1
                      ]
                    : ''
                }
                onChange={(e) => {
                  props.setSectionDrawerVisualType(
                    ('shaker_' + e.target.value) as DrawerVisualType
                  )
                }}
              >
                <FormControlLabel
                  value="h"
                  control={<Radio color="primary" />}
                  label="Horizontal"
                />
                <FormControlLabel
                  value="v"
                  control={<Radio color="primary" />}
                  label="Vertical"
                />
              </RadioGroup>
            </FormControl>
          )}
        </Paper>
      </Slide>

      {/* <Slide direction="left" in={!!props.drawerProps}>
        <Box
          style={{
            position: 'absolute',
            height: 36,
            left: props.left + 35 + 100,
            top: props.top + 48 - 25 + 36 * 3 + 10 * 3, //48 is header height
            display: 'flex',
            zIndex: 20,
            // alignItems: 'center',
          }}
          sx={{
            flexDirection: 'column',
            ml: 1,
          }}
        >
          <Box display="flex" alignItems="center" style={{ columnGap: 5 }}>
            <TypeButton
              selectedType={
                props.drawerProps?.handleProps.orientation || 'vertical'
              }
              type="vertical"
              setType={props.setDrawerHandleOrientation}
            >
              <DrawerSVG />
            </TypeButton>
            <TypeButton
              selectedType={
                props.drawerProps?.handleProps.orientation || 'vertical'
              }
              type="double_horizontal"
              setType={props.setDrawerHandleOrientation}
            >
              <DrawerDoubleSVG />
            </TypeButton>
            <Fab
              style={{
                maxWidth: 25,
                maxHeight: 25,
                minWidth: 25,
                minHeight: 25,
              }}
              color="secondary"
              onClick={() => {
                props.deleteSectionDrawer()
              }}
            >
              <DeleteIcon />
            </Fab>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            style={{ columnGap: 5 }}
            mt={1}
          >
            <TypeButton
              selectedType={
                typeof drawerHandlePos === 'string' ? drawerHandlePos : 'none'
              }
              type="forDrawer"
              setType={(v) => props.setDrawerHandlePosition('forDrawer')}
            >
              <DrawerSVG />
            </TypeButton>

            <TypeButton
              selectedType={
                typeof drawerHandlePos === 'string' ? drawerHandlePos : 'none'
              }
              type="forDrawerCenter"
              setType={(v) => props.setDrawerHandlePosition('forDrawerCenter')}
            >
              <DrawerCenterSVG />
            </TypeButton>
            <TextField
              label={unit}
              variant="outlined"
              size="small"
              type="number"
              style={{
                width: 80,
              }}
              onFocus={(e) => {
                handleFocus(e)
              }}
              value={
                typeof drawerHandlePos === 'number'
                  ? unit === 'cm'
                    ? drawerHandlePos
                    : cmToIn(drawerHandlePos)
                  : -1
              }
              onChange={(e) => {
                const newValue = parseFloat(e.target.value)
                props.setDrawerHandlePosition(
                  unit === 'cm' ? newValue : inToCm(newValue)
                )
              }}
            />
          </Box>
          <Box
            display="flex"
            alignItems="center"
            style={{ columnGap: 5 }}
            mt={1}
          >
            <TypeButton
              selectedType={
                typeof drawerHandlePosX === 'string' ? drawerHandlePosX : 'none'
              }
              type="left"
              setType={(v: HandlePositionXTypes) =>
                props.setDrawerHandlePositionX(v)
              }
            >
              <DrawerLeftSVG />
            </TypeButton>
            <TypeButton
              selectedType={
                typeof drawerHandlePosX === 'string' ? drawerHandlePosX : 'none'
              }
              type="center"
              setType={(v: HandlePositionXTypes) =>
                props.setDrawerHandlePositionX(v)
              }
            >
              <DrawerSVG />
            </TypeButton>
            <TypeButton
              selectedType={
                typeof drawerHandlePosX === 'string' ? drawerHandlePosX : 'none'
              }
              type="right"
              setType={(v: HandlePositionXTypes) =>
                props.setDrawerHandlePositionX(v)
              }
            >
              <DrawerRightSVG />
            </TypeButton>

            <TextField
              label={unit}
              variant="outlined"
              size="small"
              type="number"
              style={{
                width: 80,
              }}
              onFocus={(e) => {
                handleFocus(e)
              }}
              value={
                typeof drawerHandlePosX === 'number'
                  ? unit === 'cm'
                    ? drawerHandlePosX
                    : cmToIn(drawerHandlePosX)
                  : -1
              }
              onChange={(e) => {
                const newValue = parseFloat(e.target.value)
                props.setDrawerHandlePositionX(
                  unit === 'cm' ? newValue : inToCm(newValue)
                )
              }}
            />
          </Box>
          <Box
            display="flex"
            alignItems="center"
            style={{ marginTop: 8, columnGap: 5 }}
          >
            <TypeButton
              selectedType={props.drawerProps?.visualType || 'standard'}
              type="standard"
              setType={props.setSectionDrawerVisualType}
            >
              <DrawerSVG />
            </TypeButton>
            <TypeButton
              selectedType={props.drawerProps?.visualType || 'standard'}
              type="fivePieces"
              setType={props.setSectionDrawerVisualType}
            >
              <DrawerSVG />
            </TypeButton>
            <TypeButton
              selectedType={props.drawerProps?.visualType || 'standard'}
              type="#"
              setType={() => {
                props.setSectionDrawerVisualType(newDoorVisualTypeValues[0])
              }}
            >
              <DrawerNewSVG />
            </TypeButton>
            <TypeButton
              selectedType={props.drawerProps?.visualType || 'standard'}
              type="shaker"
              setType={() => props.setSectionDrawerVisualType('shaker_h')}
            >
              <DrawerSVG />
            </TypeButton>
          </Box>
          {isNewDrawerVisualType && (
            <Flex sx={{ mt: 2 }} column gap={1}>
              <FormControl size="small" sx={{ width: 180 }}>
                <InputLabel>New Drawer Visual Type</InputLabel>
                <Select
                  defaultValue={newDoorVisualTypeValues[0]}
                  value={
                    props.drawerProps?.visualType || newDoorVisualTypeValues[0]
                  }
                  label={'New Drawer Visual Type'}
                  onChange={(e) => {
                    props.setSectionDrawerVisualType(
                      e.target.value as DrawerVisualType
                    )
                  }}
                >
                  {newDoorVisualTypeValues.map((v) => (
                    <MenuItem value={v} key={'dv' + v}>
                      {v}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Flex>
          )}
          {isDrawerShakerVisualType && (
            <FormControl component="fieldset">
              <RadioGroup
                row
                value={
                  props.drawerProps?.visualType
                    ? props.drawerProps?.visualType[
                        props.drawerProps?.visualType.length - 1
                      ]
                    : ''
                }
                onChange={(e) => {
                  props.setSectionDrawerVisualType(
                    ('shaker_' + e.target.value) as DrawerVisualType
                  )
                }}
              >
                <FormControlLabel
                  value="h"
                  control={<Radio color="primary" />}
                  label="Horizontal"
                />
                <FormControlLabel
                  value="v"
                  control={<Radio color="primary" />}
                  label="Vertical"
                />
              </RadioGroup>
            </FormControl>
          )}
        </Box>
      </Slide> */}

      <Slide direction="up" in={!!props.doorProps}>
        <Paper
          style={{
            position: 'absolute',
            padding: 8,
            right: 488,
            bottom: 64, //48 is header height
            display: 'flex',
            zIndex: 20,
            // alignItems: 'center',
          }}
          sx={{
            flexDirection: 'column',
            ml: 1,
          }}
        >
          <Flex centerY>
            <Typography style={{ fontSize: 18, flexGrow: 1 }}>
              Door Options
            </Typography>
            <Fab
              style={{
                maxWidth: 25,
                maxHeight: 25,
                minWidth: 25,
                minHeight: 25,
              }}
              color="secondary"
              onClick={() => {
                props.deleteSectionDoor()
              }}
            >
              <DeleteIcon />
            </Fab>
          </Flex>
          <Divider
            sx={{
              margin: '8px -8px',
            }}
          />
          <Box display="flex" alignItems="center" style={{ columnGap: 5 }}>
            <TypeButton
              selectedType={doorType}
              type="right"
              setType={props.setSectionDoor}
            >
              <LeftDoorSVG />
            </TypeButton>
            <TypeButton
              selectedType={doorType}
              type="left"
              setType={props.setSectionDoor}
            >
              <RightDoorSVG />
            </TypeButton>
            {!props.isCorner && (
              <TypeButton
                selectedType={doorType}
                type="double"
                setType={props.setSectionDoor}
              >
                <DoubleDoorSVG />
              </TypeButton>
            )}
            {!props.isTwoDoorCorner && (
              <TypeButton
                selectedType={doorType}
                type="liftUp"
                setType={props.setSectionDoor}
              >
                <LiftUpDoorSVG />
              </TypeButton>
            )}
          </Box>
          <Box
            display="flex"
            alignItems="center"
            style={{ columnGap: 5 }}
            mt={1}
          >
            <TypeButton
              selectedType={typeof handlePos === 'string' ? handlePos : 'none'}
              type="bottom"
              setType={setHandlePosition}
            >
              <BottomHandleSVG />
            </TypeButton>
            {doorType !== 'liftUp' && (
              <>
                <TypeButton
                  selectedType={
                    typeof handlePos === 'string' ? handlePos : 'none'
                  }
                  type="center"
                  setType={setHandlePosition}
                >
                  <DoubleDoorSVG />
                </TypeButton>
                <TypeButton
                  selectedType={
                    typeof handlePos === 'string' ? handlePos : 'none'
                  }
                  type="top"
                  setType={setHandlePosition}
                >
                  <TopHandleSVG />
                </TypeButton>
              </>
            )}

            <TextField
              label={unit}
              variant="outlined"
              size="small"
              type="number"
              style={{
                width: 80,
              }}
              onFocus={(e) => {
                handleFocus(e)
              }}
              value={
                typeof handlePos === 'number'
                  ? unit === 'cm'
                    ? handlePos
                    : cmToIn(handlePos)
                  : -1
              }
              onChange={(e) => {
                const newValue = parseFloat(e.target.value)
                props.setSectionDoorHandlePosition(
                  unit === 'cm' ? newValue : inToCm(newValue)
                )
              }}
            />

            <TypeButton
              selectedType={typeof handlePos === 'string' ? handlePos : 'none'}
              type="fromGround"
              setType={setHandlePosition}
            >
              <FromGroundSVG />
            </TypeButton>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            style={{ columnGap: 5 }}
            mt={1}
          >
            {!(props.isTwoDoorCorner && doorType === 'left') && (
              <TypeButton
                selectedType={
                  typeof handlePosX === 'string' ? handlePosX : 'none'
                }
                type="left"
                setType={(v: HandlePositionXTypes) =>
                  props.setSectionDoorHandlePositionX(v)
                }
              >
                <LeftDoorSVG />
              </TypeButton>
            )}
            {!props.isTwoDoorCorner && (
              <TypeButton
                selectedType={
                  typeof handlePosX === 'string' ? handlePosX : 'none'
                }
                type="center"
                setType={(v: HandlePositionXTypes) =>
                  props.setSectionDoorHandlePositionX(v)
                }
              >
                <CenterHandleSVG />
              </TypeButton>
            )}
            {!(props.isTwoDoorCorner && doorType === 'right') && (
              <TypeButton
                selectedType={
                  typeof handlePosX === 'string' ? handlePosX : 'none'
                }
                type="right"
                setType={(v: HandlePositionXTypes) =>
                  props.setSectionDoorHandlePositionX(v)
                }
              >
                <RightDoorSVG />
              </TypeButton>
            )}

            <TextField
              label={unit}
              variant="outlined"
              size="small"
              type="number"
              style={{
                width: 80,
              }}
              onFocus={(e) => {
                handleFocus(e)
              }}
              value={
                typeof handlePosX === 'number'
                  ? unit === 'cm'
                    ? handlePosX
                    : cmToIn(handlePosX)
                  : -1
              }
              onChange={(e) => {
                const newValue = parseFloat(e.target.value)
                props.setSectionDoorHandlePositionX(
                  unit === 'cm' ? newValue : inToCm(newValue)
                )
              }}
            />
          </Box>
          {doorType === 'liftUp' ? (
            <Box display="flex" alignItems="center" style={{ columnGap: 5 }}>
              <TypeButton
                selectedType={handleOrientation}
                type="vertical"
                setType={props.setHandleOrientation}
              >
                <DrawerSVG />
              </TypeButton>
              <TypeButton
                selectedType={handleOrientation}
                type="double_horizontal"
                setType={props.setHandleOrientation}
              >
                <DrawerDoubleSVG />
              </TypeButton>
            </Box>
          ) : (
            <Box
              display="flex"
              alignItems="center"
              style={{ columnGap: 5 }}
              mt={1}
            >
              <TypeButton
                selectedType={handleOrientation}
                type="vertical"
                setType={props.setHandleOrientation}
              >
                <CenterHandleSVG />
              </TypeButton>
              <TypeButton
                selectedType={handleOrientation}
                type="horizontal"
                setType={props.setHandleOrientation}
              >
                <HorizontalHandleSVG />
              </TypeButton>
            </Box>
          )}

          <Box
            display="flex"
            alignItems="center"
            style={{ columnGap: 5 }}
            mt={1}
          >
            <TypeButton
              selectedType={doorVisualType}
              type="vGroove"
              setType={props.setSectionDoorVisualType}
            >
              <VGrooveDoorSVG />
            </TypeButton>
            <TypeButton
              selectedType={doorVisualType}
              type="fivePieces"
              setType={props.setSectionDoorVisualType}
            >
              <FivePiecesDoorSVG />
            </TypeButton>
            <TypeButton
              selectedType={doorVisualType}
              type="#"
              setType={() => {
                props.setSectionDoorVisualType(newDoorVisualTypeValues[0])
              }}
            >
              <NewDoorSVG />
            </TypeButton>
            <TypeButton
              selectedType={doorVisualType}
              type="shaker"
              setType={() => props.setSectionDoorVisualType('shaker_h')}
            >
              <ShakerDoorSVG />
            </TypeButton>
          </Box>
          {(isNewDoorVisualType || doorVisualType === 'fivePieces') && (
            <Flex sx={{ mt: 2 }} column gap={1}>
              {isNewDoorVisualType ? (
                <FormControl size="small" sx={{ width: 180 }}>
                  <InputLabel>New Door Visual Type</InputLabel>
                  <Select
                    defaultValue={newDoorVisualTypeValues[0]}
                    value={doorVisualType}
                    label={'New Door Visual Type'}
                    onChange={(e) => {
                      props.setSectionDoorVisualType(
                        e.target.value as DoorVisualType
                      )
                    }}
                  >
                    {newDoorVisualTypeValues.map((v) => (
                      <MenuItem value={v} key={'dv' + v}>
                        {v}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              ) : (
                <></>
              )}
              <TextField
                label={'Splitters - ' + newDoorsDistY}
                variant="outlined"
                size="small"
                style={{
                  width: 180,
                }}
                onFocus={(e) => {
                  handleFocus(e)
                }}
                value={(() => {
                  let value = props.doorProps?.normalMapSplitter || ''
                  // console.log('-------', value)

                  if (unit === 'in') {
                    const numbers = value.split(',')
                    const numbersInInch = []

                    for (const num of numbers) {
                      const n = parseFloat(num)

                      if (isNaN(n)) {
                        const letter = num[0]
                        const _num = num.slice(1)
                        const n = parseFloat(_num)

                        if (isNaN(n)) {
                          numbersInInch.push(num)
                        } else {
                          numbersInInch.push(letter + cmToIn(n))
                        }
                      } else {
                        numbersInInch.push(cmToIn(n))
                      }
                    }

                    value = numbersInInch.join(',')
                  }
                  return value
                })()}
                onChange={(e) => {
                  const acceptableSymbols = [
                    '1',
                    '2',
                    '3',
                    '4',
                    '5',
                    '6',
                    '7',
                    '8',
                    '9',
                    '0',
                    '.',
                    ',',
                    'X',
                    'x',
                    'C',
                    'c',
                    'M',
                    'm',
                    'F',
                    'f',
                  ]

                  if (
                    e.target.value
                      .split('')
                      .every((s) => acceptableSymbols.includes(s))
                  ) {
                    let value = e.target.value.toUpperCase()

                    if (unit === 'in') {
                      const numbers = value.split(',')
                      const numbersInInch = []

                      for (const num of numbers) {
                        const n = parseFloat(num)

                        if (isNaN(n)) {
                          const letter = num[0]
                          const _num = num.slice(1)
                          const n = parseFloat(_num)

                          if (isNaN(n)) {
                            numbersInInch.push(num)
                          } else {
                            numbersInInch.push(letter + inToCm(n))
                          }
                        } else {
                          numbersInInch.push(inToCm(n))
                        }
                      }

                      value = numbersInInch.join(',')
                    }

                    props.setSectionDoorSplitters(value)
                  }
                }}
              />
              <TextField
                label={'Splitters Overview'}
                variant="outlined"
                size="small"
                style={{
                  width: 180,
                }}
                value={getNewDoorPiecesFromSplitters(
                  props.doorProps?.normalMapSplitter || '',
                  props.panelHeight,
                  unit || 'cm'
                )
                  .map((s) =>
                    s.holeType === 'none'
                      ? s.num
                      : s.holeType[0].toUpperCase() + s.num
                  )
                  .join(',')}
                onClick={() => {
                  props.setSectionDoorSplitters(
                    getNewDoorPiecesFromSplitters(
                      props.doorProps?.normalMapSplitter || '',
                      props.panelHeight,
                      'cm'
                    )
                      .map((s) =>
                        s.holeType === 'none'
                          ? s.num
                          : s.holeType[0].toUpperCase() + s.num
                      )
                      .join(',')
                  )
                }}
              />
            </Flex>
          )}

          {isShakerVisualType && (
            <FormControl component="fieldset">
              <RadioGroup
                row
                value={doorVisualType[doorVisualType.length - 1]}
                onChange={(e) => {
                  props.setSectionDoorVisualType(
                    ('shaker_' + e.target.value) as DoorVisualType
                  )
                }}
              >
                <FormControlLabel
                  value="h"
                  control={<Radio color="primary" />}
                  label="Horizontal"
                />
                <FormControlLabel
                  value="v"
                  control={<Radio color="primary" />}
                  label="Vertical"
                />
              </RadioGroup>
            </FormControl>
          )}
        </Paper>
      </Slide>

      {/* <Slide direction="left" in={!!props.doorProps}>
        <Paper
          style={{
            position: 'absolute',
            left: props.left + 35 + 100,
            top: props.top, //+ 48 - 25 + 36 * 2 + 10 * 2, //48 is header height
            zIndex: 20,
            padding: 8,
          }}
        >
          <Box display="flex" alignItems="center" style={{ columnGap: 5 }}>
            <TypeButton
              selectedType={doorType}
              type="right"
              setType={props.setSectionDoor}
            >
              <LeftDoorSVG />
            </TypeButton>
            <TypeButton
              selectedType={doorType}
              type="left"
              setType={props.setSectionDoor}
            >
              <RightDoorSVG />
            </TypeButton>
            {!props.isCorner && (
              <TypeButton
                selectedType={doorType}
                type="double"
                setType={props.setSectionDoor}
              >
                <DoubleDoorSVG />
              </TypeButton>
            )}
            <TypeButton
              selectedType={doorType}
              type="liftUp"
              setType={props.setSectionDoor}
            >
              <LiftUpDoorSVG />
            </TypeButton>

            <Fab
              style={{
                maxWidth: 25,
                maxHeight: 25,
                minWidth: 25,
                minHeight: 25,
              }}
              color="secondary"
              onClick={() => {
                props.deleteSectionDoor()
              }}
            >
              <DeleteIcon />
            </Fab>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            style={{ columnGap: 5 }}
            mt={1}
          >
            <TypeButton
              selectedType={typeof handlePos === 'string' ? handlePos : 'none'}
              type="bottom"
              setType={setHandlePosition}
            >
              <BottomHandleSVG />
            </TypeButton>
            <TypeButton
              selectedType={typeof handlePos === 'string' ? handlePos : 'none'}
              type="center"
              setType={setHandlePosition}
            >
              <DoubleDoorSVG />
            </TypeButton>
            <TypeButton
              selectedType={typeof handlePos === 'string' ? handlePos : 'none'}
              type="top"
              setType={setHandlePosition}
            >
              <TopHandleSVG />
            </TypeButton>

            <TextField
              label={unit}
              variant="outlined"
              size="small"
              type="number"
              style={{
                width: 80,
              }}
              onFocus={(e) => {
                handleFocus(e)
              }}
              value={
                typeof handlePos === 'number'
                  ? unit === 'cm'
                    ? handlePos
                    : cmToIn(handlePos)
                  : -1
              }
              onChange={(e) => {
                const newValue = parseFloat(e.target.value)
                props.setSectionDoorHandlePosition(
                  unit === 'cm' ? newValue : inToCm(newValue)
                )
              }}
            />

            <TypeButton
              selectedType={typeof handlePos === 'string' ? handlePos : 'none'}
              type="fromGround"
              setType={setHandlePosition}
            >
              <FromGroundSVG />
            </TypeButton>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            style={{ columnGap: 5 }}
            mt={1}
          >
            <TypeButton
              selectedType={
                typeof handlePosX === 'string' ? handlePosX : 'none'
              }
              type="left"
              setType={(v: HandlePositionXTypes) =>
                props.setSectionDoorHandlePositionX(v)
              }
            >
              <LeftDoorSVG />
            </TypeButton>
            <TypeButton
              selectedType={
                typeof handlePosX === 'string' ? handlePosX : 'none'
              }
              type="center"
              setType={(v: HandlePositionXTypes) =>
                props.setSectionDoorHandlePositionX(v)
              }
            >
              <CenterHandleSVG />
            </TypeButton>
            <TypeButton
              selectedType={
                typeof handlePosX === 'string' ? handlePosX : 'none'
              }
              type="right"
              setType={(v: HandlePositionXTypes) =>
                props.setSectionDoorHandlePositionX(v)
              }
            >
              <RightDoorSVG />
            </TypeButton>

            <TextField
              label={unit}
              variant="outlined"
              size="small"
              type="number"
              style={{
                width: 80,
              }}
              onFocus={(e) => {
                handleFocus(e)
              }}
              value={
                typeof handlePosX === 'number'
                  ? unit === 'cm'
                    ? handlePosX
                    : cmToIn(handlePosX)
                  : -1
              }
              onChange={(e) => {
                const newValue = parseFloat(e.target.value)
                props.setSectionDoorHandlePositionX(
                  unit === 'cm' ? newValue : inToCm(newValue)
                )
              }}
            />
          </Box>
          <Box
            display="flex"
            alignItems="center"
            style={{ columnGap: 5 }}
            mt={1}
          >
            <TypeButton
              selectedType={handleOrientation}
              type="vertical"
              setType={props.setHandleOrientation}
            >
              <CenterHandleSVG />
            </TypeButton>
            <TypeButton
              selectedType={handleOrientation}
              type="horizontal"
              setType={props.setHandleOrientation}
            >
              <HorizontalHandleSVG />
            </TypeButton>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            style={{ columnGap: 5 }}
            mt={1}
          >
            <TypeButton
              selectedType={doorVisualType}
              type="vGroove"
              setType={props.setSectionDoorVisualType}
            >
              <VGrooveDoorSVG />
            </TypeButton>
            <TypeButton
              selectedType={doorVisualType}
              type="fivePieces"
              setType={props.setSectionDoorVisualType}
            >
              <FivePiecesDoorSVG />
            </TypeButton>
            <TypeButton
              selectedType={doorVisualType}
              type="#"
              setType={() => {
                props.setSectionDoorVisualType(newDoorVisualTypeValues[0])
              }}
            >
              <NewDoorSVG />
            </TypeButton>
            <TypeButton
              selectedType={doorVisualType}
              type="shaker"
              setType={() => props.setSectionDoorVisualType('shaker_h')}
            >
              <ShakerDoorSVG />
            </TypeButton>
          </Box>
          {(isNewDoorVisualType || doorVisualType === 'fivePieces') && (
            <Flex sx={{ mt: 2 }} column gap={1}>
              {isNewDoorVisualType ? (
                <FormControl size="small" sx={{ width: 180 }}>
                  <InputLabel>New Door Visual Type</InputLabel>
                  <Select
                    defaultValue={newDoorVisualTypeValues[0]}
                    value={doorVisualType}
                    label={'New Door Visual Type'}
                    onChange={(e) => {
                      props.setSectionDoorVisualType(
                        e.target.value as DoorVisualType
                      )
                    }}
                  >
                    {newDoorVisualTypeValues.map((v) => (
                      <MenuItem value={v} key={'dv' + v}>
                        {v}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              ) : (
                <></>
              )}
              <TextField
                label={'Splitters - ' + newDoorsDistY}
                variant="outlined"
                size="small"
                style={{
                  width: 180,
                }}
                onFocus={(e) => {
                  handleFocus(e)
                }}
                value={(() => {
                  let value = props.doorProps?.normalMapSplitter || ''
                  // console.log('-------', value)

                  if (unit === 'in') {
                    const numbers = value.split(',')
                    const numbersInInch = []

                    for (const num of numbers) {
                      const n = parseFloat(num)

                      if (isNaN(n)) {
                        const letter = num[0]
                        const _num = num.slice(1)
                        const n = parseFloat(_num)

                        if (isNaN(n)) {
                          numbersInInch.push(num)
                        } else {
                          numbersInInch.push(letter + cmToIn(n))
                        }
                      } else {
                        numbersInInch.push(cmToIn(n))
                      }
                    }

                    value = numbersInInch.join(',')
                  }
                  return value
                })()}
                onChange={(e) => {
                  const acceptableSymbols = [
                    '1',
                    '2',
                    '3',
                    '4',
                    '5',
                    '6',
                    '7',
                    '8',
                    '9',
                    '0',
                    '.',
                    ',',
                    'X',
                    'x',
                    'C',
                    'c',
                    'M',
                    'm',
                    'F',
                    'f',
                  ]

                  if (
                    e.target.value
                      .split('')
                      .every((s) => acceptableSymbols.includes(s))
                  ) {
                    let value = e.target.value.toUpperCase()

                    if (unit === 'in') {
                      const numbers = value.split(',')
                      const numbersInInch = []

                      for (const num of numbers) {
                        const n = parseFloat(num)

                        if (isNaN(n)) {
                          const letter = num[0]
                          const _num = num.slice(1)
                          const n = parseFloat(_num)

                          if (isNaN(n)) {
                            numbersInInch.push(num)
                          } else {
                            numbersInInch.push(letter + inToCm(n))
                          }
                        } else {
                          numbersInInch.push(inToCm(n))
                        }
                      }

                      value = numbersInInch.join(',')
                    }

                    props.setSectionDoorSplitters(value)
                  }
                }}
              />
              <TextField
                label={'Splitters Overview'}
                variant="outlined"
                size="small"
                style={{
                  width: 180,
                }}
                value={getNewDoorPiecesFromSplitters(
                  props.doorProps?.normalMapSplitter || '',
                  props.panelHeight,
                  unit || 'cm'
                )
                  .map((s) =>
                    s.holeType === 'none'
                      ? s.num
                      : s.holeType[0].toUpperCase() + s.num
                  )
                  .join(',')}
                onClick={() => {
                  props.setSectionDoorSplitters(
                    getNewDoorPiecesFromSplitters(
                      props.doorProps?.normalMapSplitter || '',
                      props.panelHeight,
                      'cm'
                    )
                      .map((s) =>
                        s.holeType === 'none'
                          ? s.num
                          : s.holeType[0].toUpperCase() + s.num
                      )
                      .join(',')
                  )
                }}
              />
            </Flex>
          )}

          {isShakerVisualType && (
            <FormControl component="fieldset">
              <RadioGroup
                row
                value={doorVisualType[doorVisualType.length - 1]}
                onChange={(e) => {
                  props.setSectionDoorVisualType(
                    ('shaker_' + e.target.value) as DoorVisualType
                  )
                }}
              >
                <FormControlLabel
                  value="h"
                  control={<Radio color="primary" />}
                  label="Horizontal"
                />
                <FormControlLabel
                  value="v"
                  control={<Radio color="primary" />}
                  label="Vertical"
                />
              </RadioGroup>
            </FormControl>
          )}
        </Paper>
      </Slide> */}

      <Slide direction="left" in={dividerMode}>
        <Box
          display="flex"
          alignItems="center"
          style={{
            position: 'absolute',
            left: props.left + 35 + 100,
            top: props.top + 48 - 25, //48 is header height
            columnGap: 5,
            zIndex: 20,
          }}
        >
          <TextField
            label="count"
            variant="outlined"
            size="small"
            type="number"
            style={{
              width: 80,
            }}
            value={dividerCount}
            onChange={(e) => {
              const val = parseInt(e.target.value)
              if (val > 0) {
                setDividerCount(val)
                props.viewDividers(val)
              } else {
                props.viewDividers(1)
              }
            }}
          />
          <Fab
            style={{
              background: '#7EE214',
              color: 'white',
              maxWidth: 25,
              maxHeight: 25,
              minWidth: 25,
              minHeight: 25,
            }}
            onClick={() => {
              setDividerMode(false)
              props.addTempDividers()
            }}
          >
            <CheckIcon />
          </Fab>
          <Fab
            style={{
              maxWidth: 25,
              maxHeight: 25,
              minWidth: 25,
              minHeight: 25,
            }}
            color="secondary"
            onClick={() => {
              props.removeTempDividers()
              setDividerMode(false)
            }}
          >
            <CloseIcon />
          </Fab>
        </Box>
      </Slide>

      <Slide direction="left" in={shelfMode}>
        <Box
          display="flex"
          alignItems="center"
          style={{
            position: 'absolute',
            left: props.left + 35 + 100,
            top: props.top + 48 - 25 + 36 + 10, //48 is header height
            columnGap: 5,
            zIndex: 20,
          }}
        >
          <TextField
            label="count"
            variant="outlined"
            size="small"
            type="number"
            style={{
              width: 80,
            }}
            value={shelfCount}
            onChange={(e) => {
              const val = parseInt(e.target.value)
              if (val > 0) {
                setShelfCount(val)
                props.viewShelf(val)
              }
            }}
          />
          <Fab
            style={{
              background: '#7EE214',
              color: 'white',
              maxWidth: 25,
              maxHeight: 25,
              minWidth: 25,
              minHeight: 25,
            }}
            onClick={() => {
              setShelfMode(false)
              props.addShelvesAsItem(shelfCount)
            }}
          >
            <CheckIcon />
          </Fab>

          <Fab
            style={{
              maxWidth: 25,
              maxHeight: 25,
              minWidth: 25,
              minHeight: 25,
            }}
            color="secondary"
            onClick={turnOffShelvesMode}
          >
            <CloseIcon />
          </Fab>

          <Fab
            style={{
              maxWidth: 25,
              maxHeight: 25,
              minWidth: 25,
              minHeight: 25,
            }}
            color="secondary"
            onClick={() => {
              props.deleteShelves()
              setShelfMode(false)
            }}
          >
            <DeleteIcon />
          </Fab>
        </Box>
      </Slide>
    </>
  )
}

export default SectionActions
